import { Divider, Typography } from 'antd';
import { type Assistant } from '@entities/assistant';
import { DeleteAssistantButton } from '@features/delete-assistant';
import { EditAssistantForm } from '@features/edit-assistant';

const { Title, Text } = Typography;

interface Props {
  assistant: Assistant;
}

export function SettingsTab({ assistant }: Props) {
  return (
    <div>
      <EditAssistantForm assistant={assistant} />

      <Divider style={{ margin: '32px 0 24px' }} />

      <Title level={5} style={{ marginTop: 0, marginBottom: 8 }}>
        Опасная зона
      </Title>
      <Text type="secondary" style={{ fontSize: 13, display: 'block', marginBottom: 12 }}>
        Удаление ассистента сотрёт его базу знаний и историю чатов без возможности
        восстановления.
      </Text>

      <DeleteAssistantButton assistantId={assistant.id} assistantName={assistant.name} />
    </div>
  );
}
